import React, { useState } from "react"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

import { changeOrderStatusToDelivered } from "services"
import { Button } from "components"
import classes from "./OhDeliveredButton.module.scss"

const OhDeliveredButton = props => {
  const {
    order,
    setOrders,
    disabledButton,
    setDisableButton
  } = props

  const [t] = useTranslation()

  const [sending, setSending] = useState(false)

  const handleClick = async () => {
    setSending(true)

    setDisableButton("canceled")

    try {
      await changeOrderStatusToDelivered(order._id)

      setOrders(prev =>
        prev.map(o =>
          order._id === o._id ? { ...o, orderStatus: "delivered" } : o
        )
      )

      toast.success(t("سفارش_تکمیل_شد"))
    } catch (err) {
      console.log(err)

      toast.error(t("سفارش_تکمیل_نشد"))
    }

    setSending(false)
  }

  return (
    <div className={classes["container"]}>
      <Button
        color="success"
        fullWidth
        disabled={disabledButton === "delivered"}
        loading={sending}
        onClick={handleClick}
      >
        {t("تکمیل_سفارش")}
      </Button>
    </div>

  )
}

export default OhDeliveredButton